import React from 'react';
import { Button, Menu, MenuItem } from '@material-ui/core';
import { ExitToApp, Person, AccountBox } from '@material-ui/icons';
import LockIcon from '@material-ui/icons/Lock';
import { Link } from 'react-router-dom';
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import * as userSessionActions from '../../redux/actions/user-session';
import { removeUserSession } from '../../redux/actions/user-session';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl'
import ChangePasswordDialog from '../change-password-dialog';
import CustomizedSnackbars from '../material-snackbars';

function UserMenu(props) {

  let history = useHistory();
  const intl = props.intl;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [changePasswordOpen, setChangePasswordOpen] = React.useState(false);
  const [snack, setSnack] = React.useState({ open: false, variant: 'success', message: '' });

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openChangePassword = () => {
    handleClose();
    setChangePasswordOpen(true);
  };

  const closeChangePassword = () => setChangePasswordOpen(false);

  const handleChangePasswordSuccess = (msg) => {
    setSnack({ open: true, variant: 'success', message: msg });
  };

  const logOut = () => {
    handleClose();
    removeUserSession();
    history.push("/");
  };

  return (
    <div>
      <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        <Person style={{ color: '#FFF' }} />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose} component={Link} {...{ to: `/${props.match.params.lang}/user-edit-client` }}>
          <AccountBox />
          <span style={{ marginLeft: '10px' }}><FormattedMessage id="my.data"/></span>
        </MenuItem>

        <MenuItem onClick={openChangePassword}>
          <LockIcon />
          <span style={{ marginLeft: '10px' }}><FormattedMessage id="change.password"/></span>
        </MenuItem>

        <MenuItem onClick={logOut}>
          <ExitToApp />
          <span style={{ marginLeft: '10px' }}>Logout</span>
        </MenuItem>

      </Menu>

      <ChangePasswordDialog
        open={changePasswordOpen}
        onClose={closeChangePassword}
        onSuccess={handleChangePasswordSuccess}
      />
      <CustomizedSnackbars
        variant={snack.variant}
        message={snack.message}
        isOpen={snack.open}
        toClose={() => setSnack(s => ({ ...s, open: false }))}
      />
    </div>
  );
}

const mapStateToProps = state => ({
  userSession: state.userSession,
});

//const mapDispatchToProps = dispatch => ({
//  resetSession: () => dispatch(userSessionActions.removeUserSession())
//});

const mapDispatchToProps = dispatch =>
  bindActionCreators(userSessionActions, dispatch);

//export default connect(mapStateToProps, mapDispatchToProps)(UserMenu)
export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(UserMenu))))
